<template>
  <f-input #suffix v-model.number="model" :mask="moneyMask" number inputmode="numeric">
    <f-affix suffix label="kr" />
  </f-input>
</template>

<script>
import { createModel, modelProps } from 'create-v-model'
import { fAffix } from '@fabric-ds/vue'

const moneyMask = { numeral: true, numeralPositiveOnly: true, numeralIntegerScale: 8, delimiter: ' ' }

export default {
  name: 'fMoney',
  components: { fAffix },
  props: modelProps(),
  setup: (props, { emit }) => ({
    model: createModel({ props, emit }),
    moneyMask,
  })
}
</script>
